export default __webpack_public_path__ + "static/giant-2-7c4da9bbc095e9afdb782f83121a97ec.jpg";